import { Slot } from "@radix-ui/react-slot";
import { type ReactElement, type ReactNode, useRef, useState } from "react";
import { ContentBottomSheet } from "./content-bottom-sheet.tsx";
import { cn } from "../../lib/utils.ts";
import {
    Dialog,
    dialogCaptionClassName,
    DialogContent,
    DialogHeaderRow,
    DialogTrigger,
} from "./dialog.tsx";

type ResponsiveSheetProps = {
    title: string;
    description?: ReactNode;
    trigger: ReactElement;
    children: ReactNode;
};

function ResponsiveSheet({
    title,
    description,
    trigger,
    children,
}: ResponsiveSheetProps) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isSheetOpen, setIsSheetOpen] = useState(false);
    const sheetTriggerRef = useRef<HTMLElement>(null);
    return (
        <>
            <div className="hidden md:block">
                <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
                    <DialogTrigger asChild>{trigger}</DialogTrigger>
                    <DialogContent
                        {...(description
                            ? {}
                            : { "aria-describedby": undefined })}
                        showCloseButton={false}
                        className="flex flex-col gap-0 overflow-hidden sm:max-w-2xl"
                    >
                        <DialogHeaderRow
                            title={title}
                            description={description}
                        />
                        <div className="mt-5 min-h-0 overflow-y-auto">
                            {children}
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
            <div className="md:hidden">
                <Slot
                    ref={sheetTriggerRef}
                    onClick={() => setIsSheetOpen(true)}
                >
                    {trigger}
                </Slot>
                <ContentBottomSheet
                    title={title}
                    open={isSheetOpen}
                    onOpenChange={setIsSheetOpen}
                    finalFocus={sheetTriggerRef}
                >
                    {description && (
                        <p
                            className={cn(
                                "mb-4 text-center",
                                dialogCaptionClassName,
                            )}
                        >
                            {description}
                        </p>
                    )}
                    {children}
                </ContentBottomSheet>
            </div>
        </>
    );
}

export { ResponsiveSheet };
